import { isLocal } from "@/utils/env-utils";

// TODO: improve keyowrd
export function containsKeywords(text, keywords) {
  const normalizedText = text.toLowerCase();
  return keywords.some((keyword) => normalizedText.includes(keyword.toLowerCase()));
}

export function applyJustOne(message, keywords) {
  let matchedKeywords = [];
  const isRule = keywords.some((keyword) => {
    if (!keyword || keyword === "") return false;

    const res = message.includes(keyword);
    if (res) matchedKeywords.push(keyword);
    return res;
  });

  if (!isRule) {
    return { isRule: false, message, modifiedMessage: message };
  }

  let modifiedMessage = message;
  keywords.forEach((keyword) => {
    modifiedMessage = modifiedMessage.replaceAll(keyword, `{{${keyword}}}`);
  });

  // 키워드를

  return {
    isRule,
    matchedKeywords,
    message,
    modifiedMessage,
  };
}

export function applyMultipleKeywordRule(message = "", keywordRules = []) {
  try {
    if (!message || message === "") return [];
    if (keywordRules.length === 0) return [];

    const result = [];
    keywordRules.forEach((keywordRule) => {
      const { isEnabled, instructionId } = keywordRule;

      if (!isEnabled) return;
      if (!instructionId) return;

      const res = applyJustOne(message, keywordRule.keywords);
      if (!res.isRule) return;

      result.push({
        keywords: keywordRule.keywords,
        originalMessage: message,
        modifiedMessage: res.modifiedMessage,
        matchedKeywords: res.matchedKeywords,
        instructionId,
      });
    });

    return result;
  } catch (error) {
    if (isLocal()) console.error(error);
    return [];
  }
}

// 위에 분리가 잘 안되있었구나 socket이 같이 들어가서
export function createHandler(socket, _rules = {}, _keywordRules = []) {
  if (!_rules) _rules = {};
  if (!_keywordRules) _keywordRules = [];

  const forbiddenWords = _rules.forbiddenWords || [];
  const goodWords = _rules.goodWords || [];

  return {
    chatHandler: (chat) => {
      try {
        const { message, hidden } = chat || {};
        if (!message) return;
        if (hidden) return;

        if (containsKeywords(message, forbiddenWords)) {
          socket.emit("event", {
            eventType: "forbiddenWords",
            fromUser: chat.profile.nickname,
          });
        }

        if (containsKeywords(message, goodWords)) {
          socket.emit("event", {
            eventType: "goodWords",
            fromUser: chat.profile.nickname,
          });
        }

        // map을 써서 성능을 향상시켜야 겠지만 일단 그대로 진행
        // 한개의 채팅이지만 두개의 룰에 다 걸리면 둘다 이벤트를 발생시켜야 한다 (지금 그렇게 됨)
        _keywordRules.forEach((keywordRule) => {
          const { keywords, animationId } = keywordRule;
          if (containsKeywords(message, keywords)) {
            socket.emit("event", {
              eventType: "keyword",
              fromUser: chat.profile.nickname,
              animationId: animationId,
            });
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    donationHandler: (donation) => {
      try {
        // donation.message
        socket.emit("event", {
          eventType: "donation",
          fromUser: (donation.profile || {}).nickname || "익명의 후원자", // 익명의 후원자면 donation.profile이 null 임
          payAmount: (donation.extras || {}).payAmount,
        });
      } catch (error) {
        console.error(error);
      }
    },
  };
}
